var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 5.33358C14.0002 5.50425 13.9348 5.67491 13.8048 5.80491L8.4715 11.1382C8.21083 11.3989 7.7895 11.3989 7.52883 11.1382L2.1955 5.80491C1.93483 5.54425 1.93483 5.12291 2.1955 4.86225C2.45617 4.60158 2.8775 4.60158 3.13817 4.86225L8.00017 9.72425L12.8622 4.86225C13.1228 4.60158 13.5442 4.60158 13.8048 4.86225C13.9348 4.99225 14.0002 5.16291 14.0002 5.33358Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.3ed340ee.svg";
export { ForwardRef as ReactComponent };